module.exports = __webpack_public_path__ + "static/media/airarabia.3ab75aaf.webp";